/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const accountRouter = {
	path: '/canteenBackcourt',
	component: Layout,
	redirect: 'canteenBackcourt',
	name: '后场',
	id: 1700000,
	meta: {
		title: '后场',
		roles: [1700000]
	},
	children: [
	// {
	// path: "orgCust",
	// name: "组织/员工",
	// redirect: "org-cust",
	// component: LayoutView,
	// id: 1701000,
	// meta: { title: "组织/员工", roles: [1701000] },
	// children: [
	// {
		// path: "org-fram",
		// component: () => import("@/leniuview/canteenBackcourt/orgCust/org-fram.vue"),
		// name: "组织架构",
		// id: 1701001,
		// meta: { title: "组织架构", roles: [1701001] },
	// },
	// {
	// path: "position-information",
	// component: () => import("@/leniuview/canteenBackcourt/orgCust/position-information"),
	// name: "职位信息",
	// id: 1701002,
	// meta: { title: "职位信息", roles: [1701002] },
	// },
	// {
	// path: "cust-info",
	// component: () => import("@/leniuview/canteenBackcourt/orgCust/cust-info"),
	// name: "人员资料",
	// id: 1701003,
	// meta: { title: "人员资料", roles: [1701003] },
	// },
	// {
	// path: "training-questionnaire",
	// component: () =>
	// import("@/leniuview/canteenBackcourt/orgCust/training-questionnaire"),
	// name: "培训问卷",
	// id: 1701004,
	// meta: { title: "培训问卷", roles: [1701004] },
	// },
	// ],
	// },
		{
			path: 'caipinReserve',
			name: '菜品留样',
			redirect: 'caipin-reserve',
			component: LayoutView,
			id: 1702000,
			meta: { title: '菜品留样', roles: [1702000] },
			children: [
				{
					path: 'material-reserve',
					component: () =>
						import('@/leniuview/canteenBackcourt/caipinReserve/material-reserve'),
					name: '原料留样',
					id: 1702001,
					meta: { title: '原料留样', roles: [1702001] }
				},
				{
					path: 'caipin-reserve',
					component: () =>
						import('@/leniuview/canteenBackcourt/caipinReserve/caipin-reserve'),
					name: '菜品留样',
					id: 1702002,
					meta: { title: '菜品留样', roles: [1702002] }
				}
			]
		},
		// {
		// path: "caipinAscend",
		// name: "菜品朔源",
		// redirect: "caipin-ascend",
		// id: 1703000,
		// meta: { title: "菜品朔源", roles: [1703000] },
		// component: LayoutView,
		// children: [
		// {
		// path: "jiucan-ascend",
		// component: () =>
		// import("@/leniuview/canteenBackcourt/caipinAscend/jiucan-ascend"),
		// name: "就餐朔源",
		// id: 1703001,
		// meta: { title: "就餐朔源", roles: [1703001] },
		// },
		// {
		// path: "caipin-ascend",
		// component: () =>
		// import("@/leniuview/canteenBackcourt/caipinAscend/caipin-ascend"),
		// name: "菜品朔源",
		// id: 1703002,
		// meta: { title: "菜品朔源", roles: [1703002] },
		// },
		// ],
		// },
		{
			path: 'pesticideDetection',
			name: '农残检测',
			redirect: 'pesticide-detection',
			component: LayoutView,
			id: 1704000,
			meta: { title: '农残检测', roles: [1704000] },
			children: [
				{
					path: 'detection-records',
					component: () =>
						import('@/leniuview/canteenBackcourt/pesticideDetection/detection-records'),
					name: '检测记录',
					id: 1704001,
					meta: { title: '检测记录', roles: [1704001] }
				}
			]
		},
		// {
		// path: "finance",
		// name: "财务",
		// redirect: "finance",
		// component: LayoutView,
		// id: 1705000,
		// meta: { title: "财务", roles: [1705000] },
		// children: [
		// {
		// path: "general-expenses",
		// component: () =>
		// import("@/leniuview/canteenBackcourt/finance/general-expenses"),
		// name: "各项费用",
		// id: 1705001,
		// meta: { title: "各项费用", roles: [1705001] },
		// },
		// ],
		// },
		{
			path: 'personComputed',
			name: '客流统计',
			component: () =>
				import(
					/* webpackChunkName: "pesticideDetection" */
					'@/leniuview/canteenBackcourt/personComputed/index.vue'
				),
			id: 1706000,
			meta: { title: '客流统计', roles: [1706000] }

		}

	]
}

export default accountRouter
